import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { take } from 'rxjs/operators';
import { LoginService } from 'src/app/services/login/login.service';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-cashier',
  templateUrl: './user-cashier.page.html',
  styleUrls: ['./user-cashier.page.scss'],
})
export class UserCashierPage implements OnInit {
  userID;

  sdk;
  inline;
  isBtnClicked = false;
  status = false;
  showPay = false;

  rands;

  private yocoPK = environment.yokoPK;
  private url = environment.webUrl;

  constructor(
    private router: Router,
    private menu: MenuController,
    private auth: AngularFireAuth,
    private userProfileService: UserProfileService,
    private httpClient: HttpClient,
    private firestore: AngularFirestore,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    // this.initPay();
    this.auth.authState.subscribe((user) => {
      if (user) {
        this.userID = user.uid;
      } else {
        this.router.navigate(['/home/login']);
      }
    });
  }

  initPay() {
    this.sdk = new window.YocoSDK({
      publicKey: this.yocoPK,
    });

    this.inline = this.sdk.inline({
      layout: 'basic',
      amountInCents: this.rands * 100,
      currency: 'ZAR',
    });
    this.inline.mount('#card-frame');

    this.inline.on('ready', (event) => {
      // console.log('ready => ' + event);
    });

    this.inline.on('validity_change', (event) => {
      // console.log('v change => ' + event.isValid());
      if (event.isValid()) {
        this.status = true;
      }
    });
  }

  pay() {
    this.isBtnClicked = true;
    this.inline
      .createToken()
      .then((result) => {
        if (result.error) {
          this.isBtnClicked = false;
          const errorMessage = result.error.message;
          alert(errorMessage);
        } else {
          const token = result.id;
          const obj = {
            token,
            amountInRands: this.rands,
            orderNo: this.userID,
          };
          return this.httpClient
            .post(this.url + '/charge.php', JSON.stringify(obj))
            .pipe(take(1))
            .subscribe((response: any) => {
              this.isBtnClicked = false;
              // console.log(response);
              if (response.status) {
                // this.userProfileService.uploadWallet(this.userID, this.rands).then(() => {
                //   alert('payment-made');
                //   this.router.navigate(['/user-orders']);
                // });

                return this.firestore
                  .collection('Users')
                  .doc(this.userID)
                  .get()
                  .pipe(take(1))
                  .subscribe((res: any) => {
                    const data = res.data();
                    if (data.hasOwnProperty('walletValue')) {
                      console.log('no');
                    }
                  });
              } else if (response.errorCode) {
                alert(response.displayMessage);
              }
            });
        }
      })
      .catch((error) => {
        this.isBtnClicked = false;
        alert('error occured: ' + JSON.stringify(error));
      });
  }

  openUserMenu(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  withdrawhist() {
    this.router.navigate(['user-withdrawal-hist']);
  }
  withdraw() {
    this.router.navigate(['user-withdraw']);
  }
  cashier() {
    this.router.navigate(['user-cashier']);
  }
  userProfile() {
    this.router.navigate(['user-home']);
  }
  userUpdate() {
    this.router.navigate(['user-update']);
  }
  userHist() {
    this.router.navigate(['user-history']);
  }
  userOrders() {
    this.router.navigate(['user-orders']);
  }

  logout() {
    this.loginService.logout();
  }
}
